import React from 'react';
import { Container } from '@pixi/react';
import PixiScaledSprite from "./PixiScaledSprite"
import PixiScaledText from "./PixiScaledText"
import { utils } from '../../utils'
import { gameStateManager } from '../../App';

class PixiTurnTimer extends React.Component
{
  state = {

    timerUntil: 0,
    timeRemaining: 0

  };

  setupTimerData()
  {
    // NOTE: Date.now() deals in UTC time, and the server sends time in UTC, so no local conversions needed.
    const timerExpireTime = this.props.timerData.timerEndUTC;

    this.setState( { timerUntil: timerExpireTime } );
    this.setState( { timeRemaining: ( timerExpireTime - Date.now() ) } );
  }

  componentDidUpdate( prevProps )
  {
    if( prevProps.timerData.timerEndUTC !== this.props.timerData.timerEndUTC )
    {
      this.setupTimerData();
    }
  }

  componentDidMount()
  {
    this.timerID = setInterval(
      () => this.tick(),
      1000
    );

    this.setupTimerData();
  }

  componentWillUnmount()
  {
    clearInterval( this.timerID );
  }

  tick()
  {
    this.setState( { timeRemaining: ( this.state.timerUntil - ( new Date() ).getTime() ) } );
  }

  render()
  {

    const stageRenderData = this.props.stageRenderData;

    const stageHeightRef = gameStateManager.canvasRefHeight;

    let timeRemainingToDisplay = Math.round( this.state.timeRemaining / 1000 );
    let timerString = "";

    if( timeRemainingToDisplay < 0 )
    {
      timeRemainingToDisplay = 0;
    }

    const numMinutes = Math.floor( timeRemainingToDisplay / 60.0 );
    const numSeconds = timeRemainingToDisplay % 60;

    timerString = ( numMinutes < 10 ? "0" : "" ) + numMinutes;

    timerString += ":";

    timerString += ( numSeconds < 10 ? "0" : "" ) + numSeconds;

    return (

      <Container >
        <PixiScaledSprite
          imageSrc={ "./ui/panel_bg.png" }
          isNineSlice={ true }
          cornerRadius={ 15 }
          stageRenderData={ stageRenderData }
          x={ stageRenderData.width - ( 317 * stageRenderData.scale ) }
          y={ stageHeightRef + 3 }
          width={ 86 }
          height={ 42 }
          anchor={ { x: 1, y: 1 } }
        />

        <PixiScaledText
          text={ timerString }
          stageRenderData={ stageRenderData }
          fontSize={ 17 }
          x={ stageRenderData.width - ( 360 * stageRenderData.scale ) }
          y={ stageHeightRef - 22 }
          anchor={ { x: 0.5, y: 0.5 } }
          style={ this.props.textStyle }
        />

      </Container>
    );
  }
}

export default PixiTurnTimer;
